angular.module('bmsApp.settings').factory('WorkflowTaskSvc', function (CRUDSvc) {
	return {
		index: function (params) {
			return CRUDSvc.get('/api/workflow/task/index', params);
		},

		acceptDeclineTraingingInvite: function (params) {
			return CRUDSvc.post('api/workflow/task/accept-decline-training', params);
		},

		setStatus: function(params) {
			return CRUDSvc.post('api/workflow/task/set-status', params);
		}
	}
});



